import { AuthenticationPage } from "../components/authentication/AuthenticationPage";

function Login(){
    return (
        <AuthenticationPage />
    )
}

export {Login}